import { GtmhubController } from "@gtmhub/core";
import { IModalComponent } from "@gtmhub/core/routing";
import { IIndicator } from "@gtmhub/error-handling";
import {
  DEFAULT_LIST_COLOR,
  ICreateListFromExisting,
  IListChartSettings,
  ListChangedEvent,
  ListService,
  ListTypes,
  ListView,
  UpdateListFiltersGroup,
} from "@gtmhub/lists";
import { CurrentUserService } from "@gtmhub/users";
import { StateService } from "@uirouter/core";
import { IComponentOptions, IController, IRootScopeService } from "angular";

export type SaveListAsResolve = {
  listType: ListTypes;
  filters: UpdateListFiltersGroup[];
  view: ListView;
  chartSettings: IListChartSettings;
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SaveListAsCtrl extends IModalComponent<SaveListAsResolve> {}
export class SaveListAsCtrl extends GtmhubController implements IController {
  saving: IIndicator;
  listName: string;

  static $inject = ["ListService", "$state", "CurrentUserService", "$rootScope"];
  constructor(private listService: ListService, private $state: StateService, private currentUserService: CurrentUserService, private $rootScope: IRootScopeService) {
    super();
  }

  onSave(): void {
    this.saving = { progress: true };

    const createListParams = this.constructCreateListParams();

    this.listService
      .createList(createListParams)
      .then((newList) => {
        delete this.saving;
        this.addNewListIdToUserSetting(newList.id);
        this.$rootScope.$broadcast("listCreated", newList, ListChangedEvent.Added);
        this.$state.go("gtmhub.list", { listId: newList.id, isNewList: true });
      })
      .catch(
        (error) =>
          (this.saving = {
            error,
          })
      );
  }

  private addNewListIdToUserSetting(id: string): void {
    const listIds = this.currentUserService.getUserSetting("listIds") || [];
    listIds.push(id);

    this.currentUserService.setUserSetting({ listIds });
  }

  private constructCreateListParams(): ICreateListFromExisting {
    return {
      chartSettings: this.resolve.chartSettings,
      color: DEFAULT_LIST_COLOR,
      // to do: remove this when "and-or-filters" are released - BE will respect filters prop only
      // filters may be empty, thus first group can be undefined
      // in this case backend sets default filters without '||' check
      filter: this.resolve.filters[0] || { booleanOperator: "and", ruleBounds: [] },
      filters: this.resolve.filters,
      title: this.listName,
      type: this.resolve.listType,
      view: this.resolve.view,
    };
  }
}

export const SaveListAsComponent: IComponentOptions = {
  controller: SaveListAsCtrl,
  templateUrl: require("./save-list-as.component.html"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
